type Props = {
  data: any
};

const DashesIfNullOrUndefined = ({ data }: Props) =>
  !data || data === null || data === 'null' ? '---' : data;

export default DashesIfNullOrUndefined;
